import api from '@/apis/system/registerAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('register', api);

const state = {
  ...crud.state,
  _config: {
    table: 'backup_database',
    field: {
      key: 'backup_database_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load danh sách
   */
  async load(context, payload) {
    let res = null;
    try {
      context.commit('updateLoading', true);
      res = await api.getBackupDatabase(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      context.commit('setItems', res.filter(x => x.type == payload.type || payload.type == undefined));
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
